import React from 'react';
import { Grid } from '@mui/material';
import { BlogCard3 } from '@components/BlogCards/BlogCard3';
import { BlogCard2 } from '@components/BlogCards/BlogCard2';
import { BlogArticle } from '@models/blog';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { LazyLoadContainer } from '@web-for-marketing/react-ui';

interface FeaturedCategoryProps {
    articles: BlogArticle[];
    categoryBlogLink: string;
    languageBlogLink: string;
    lazyLoad?: boolean;
}

export function FeaturedCategory({
    articles,
    categoryBlogLink,
    languageBlogLink,
    lazyLoad,
}: FeaturedCategoryProps): React.ReactElement {
    const displayedArticles = articles.slice(0, 3);
    const firstArticle = displayedArticles[0];
    const { prefixStringWithBaseUrl } = useStaticValues();

    return (
        <LazyLoadContainer component={Grid} container spacing={{ xs: 2, md: 4 }}>
            <Grid size={{ xs: 12, md: 4, lg: 5 }}>
                <BlogCard3
                    title={firstArticle.title}
                    linkPath={`${languageBlogLink}${firstArticle.slug}`}
                    ariaLabel={`Read more about ${firstArticle.title}`}
                    image={{
                        imagePath: prefixStringWithBaseUrl(firstArticle.cardImageUrl),
                        imageAlt: firstArticle.cardImageAlt,
                    }}
                    category={firstArticle.category.name}
                    categoryLink={`${categoryBlogLink}${firstArticle.category.slug}`}
                    publishedDateUtc={firstArticle.publishedDateUtc}
                    readMinutes={firstArticle.readMinutes}
                    lazyLoad={lazyLoad}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 8, lg: 7 }}>
                <Grid container spacing={{ xs: 2, md: 4 }}>
                    {displayedArticles.slice(1).map((card, index) => (
                        <Grid size={12} key={index}>
                            <BlogCard2
                                title={card.title}
                                linkPath={`${languageBlogLink}${card.slug}`}
                                image={{
                                    imagePath: prefixStringWithBaseUrl(card.cardImageUrl),
                                    imageAlt: card.cardImageAlt,
                                }}
                                categoryPillData={{
                                    category: card.category.name,
                                    categoryLink: `${categoryBlogLink}${card.category.slug}`,
                                }}
                                publishedDateUtc={card.publishedDateUtc}
                                readMinutes={card.readMinutes}
                                ariaLabel={`Read more about ${card.title}`}
                                lazyLoad={lazyLoad}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </LazyLoadContainer>
    );
}
